import { ChartFormItemKey } from '@tencent/chart-drawer-components/lib/schema';
import { Form } from '@tencent/wb-ext-form';
import { Controller, Loader, CustomArgs, ActionPointInfo } from '@tencent/workbench';
import { FontStyleName, FORM_CONFIGS } from './config';
import { IChartFontStyleFeature } from './font-style-interface';
import type { IDynamicLoader } from '@tencent/workbench';

@Controller({ formItems: FORM_CONFIGS })
export class ChartFontStyleController {
    constructor(@Loader(IChartFontStyleFeature) private loader: IDynamicLoader<IChartFontStyleFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Form(ChartFormItemKey.GLOBAL_FONT_STYLE_BOLD, 'onClick', { style: FontStyleName.Bold })
    public handleBoldClick(@CustomArgs() args: { style: string }, @ActionPointInfo() info): void {
        this.feature.setFontBold(!this.feature.shouldFontStyleBtnCheck(args.style));
    }

    @Form(ChartFormItemKey.GLOBAL_FONT_STYLE_ITALIC, 'onClick', { style: FontStyleName.Italic })
    public handleItalicClick(@CustomArgs() args: { style: string }, @ActionPointInfo() info): void {
        this.feature.setFontItalic(!this.feature.shouldFontStyleBtnCheck(args.style));
    }

    @Form(ChartFormItemKey.GLOBAL_FONT_STYLE_BOLD, 'value', { style: FontStyleName.Bold })
    @Form(ChartFormItemKey.GLOBAL_FONT_STYLE_ITALIC, 'value', { style: FontStyleName.Italic })
    public shouldCheck(@CustomArgs() args: { style: string }, @ActionPointInfo() info): boolean {
        return this.feature.shouldFontStyleBtnCheck(args.style);
    }
}
